import styled from 'styled-components'

const Wrapper = styled.div`
  margin: auto;
  width: 50%;
`
export default Wrapper